/* Vantrel theme behaviours. Deferred, no dependencies, nothing render-blocking.
   Everything is progressive: the page reads and the form submits without it. */
(function () {
  'use strict';

  /* ---------- Header: mobile menu ---------- */
  document.querySelectorAll('[data-menu-open]').forEach(function (btn) {
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    function open() { nav.setAttribute('open', ''); btn.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; var f = nav.querySelector('[data-menu-close]'); if (f) f.focus(); }
    function close() { nav.removeAttribute('open'); btn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; btn.focus(); }
    btn.addEventListener('click', open);
    nav.querySelectorAll('[data-menu-close]').forEach(function (c) { c.addEventListener('click', close); });
    nav.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });

  /* ---------- Header dropdown: close when clicking elsewhere or pressing Escape ---------- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.hdr__dd[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.querySelectorAll('.hdr__dd[open]').forEach(function (d) { d.removeAttribute('open'); }); });

  /* 2026-10-23: which device a sign-up is about (welcome emails switch on it): the device page they are on, else the
     last device page they visited, else none. Stored on the Klaviyo profile as signup_interest = wrap | lumen | store. */
  (function () {
    var m = location.pathname.match(/\/products\/vantrel-(wrap|lumen)/);
    if (m) { try { localStorage.setItem('vl-interest', m[1]); } catch (x) {} }
  })();
  window.vlInterest = function () {
    var m = location.pathname.match(/\/products\/vantrel-(wrap|lumen)/); if (m) return m[1];
    try { return localStorage.getItem('vl-interest') || 'store'; } catch (x) { return 'store'; }
  };

  /* ---------- Home email sign-up (same Klaviyo list as the popup) ---------- */
  document.querySelectorAll('[data-subscribe]').forEach(function (box) {
    var f = box.querySelector('[data-sub-form]'); if (!f) return;
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = f.querySelector('input[type="email"]'), email = (inp.value || '').trim();
      var err = box.querySelector('[data-sub-err]'), done = box.querySelector('[data-sub-done]');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.hidden = false; inp.focus(); return; }
      err.hidden = true;
      var btn = f.querySelector('[type="submit"]'); btn.setAttribute('aria-busy', 'true');
      var code = box.getAttribute('data-code') || '';
      var body = { data: { type: 'subscription', attributes: { custom_source: 'Home sign-up', profile: { data: { type: 'profile', attributes: { email: email, properties: { welcome_code: code, signup_interest: window.vlInterest() } } } } }, relationships: { list: { data: { type: 'list', id: box.getAttribute('data-klaviyo-list') } } } } };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(box.getAttribute('data-klaviyo-company')), {
        method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-07-15' }, body: JSON.stringify(body)
      }).then(function (r) {
        if (r.status < 200 || r.status >= 300) throw new Error('klaviyo');
        f.hidden = true; done.hidden = false;
        try { localStorage.setItem('vantrel-welcome-code', code); } catch (x) {}
        try { if (window.klaviyo) window.klaviyo.identify({ email: email }); } catch (x) {}
      }).catch(function () { err.hidden = false; })
        .finally(function () { btn.removeAttribute('aria-busy'); });
    });
  });

  /* ---------- Looping carousels: who-for (all widths), how-to steps (phones / tablets). Cards are cloned before and
     after the real set, the row starts centred on the first real card, and jumps back invisibly at either end. ---------- */
  function vlLoop(row, gapPx) {
    var wrap = row.parentNode, orig = Array.prototype.slice.call(row.children);
    if (orig.length < 3 || row.dataset.looped) return; row.dataset.looped = '1';
    orig.forEach(function (li, k) { li.setAttribute('data-n', k + 1); });
    row.classList.add('is-loop');
    orig.forEach(function (li) { var c = li.cloneNode(true); c.setAttribute('aria-hidden', 'true'); row.appendChild(c); });
    orig.slice().reverse().forEach(function (li) { var c = li.cloneNode(true); c.setAttribute('aria-hidden', 'true'); row.insertBefore(c, row.firstChild); });
    var n = orig.length;
    function step() { return row.children[n + 1].offsetLeft - row.children[n].offsetLeft; }
    function centreOn(i) { var c = row.children[i]; row.scrollLeft = c.offsetLeft - (row.clientWidth - c.offsetWidth) / 2; }
    centreOn(n);
    var t = null;
    row.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var w = step() * n, mid = row.scrollLeft + row.clientWidth / 2;
        if (mid < row.children[n].offsetLeft) row.scrollLeft += w;
        else if (mid >= row.children[2 * n].offsetLeft) row.scrollLeft -= w;
      }, 120);
    }, { passive: true });
    window.addEventListener('resize', function () { centreOn(n); });
    var p = wrap.querySelector('[data-wf-prev]'), nx = wrap.querySelector('[data-wf-next]');
    if (p) p.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (nx) nx.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
  }
  document.querySelectorAll('[data-wf-row]').forEach(function (row) { row.classList.add('wf__grid--loop'); vlLoop(row); });
  if (window.matchMedia('(max-width: 1023px)').matches) document.querySelectorAll('.chain').forEach(function (row) { vlLoop(row); });

  /* ---------- Tabs / story timeline: tap a label, its panel shows ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (box) {
    var btns = Array.prototype.slice.call(box.querySelectorAll('[data-tab]'));
    var panels = Array.prototype.slice.call(box.querySelectorAll('[data-panel]'));
    function show(i) {
      btns.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-tab') === String(i) ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== String(i); });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-tab')); }); });
  });

  /* ---------- Written reviews from the data file: 6 at a time, "Show more" ---------- */
  document.querySelectorAll('[data-rv-grid]').forEach(function (grid) {
    var btn = grid.parentNode.querySelector('[data-rv-more]'), step = parseInt(grid.getAttribute('data-step'), 10) || 6;
    var ver = grid.getAttribute('data-verified') || '', list = [], shown = 0;
    var star = '<svg viewBox="0 0 24 24" focusable="false"><path d="M12 2.41L14.38 9.74L22.08 9.74L15.85 14.26L18.23 21.59L12 17.06L5.77 21.59L8.15 14.26L1.92 9.74L9.62 9.74Z"/></svg>';
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function month(d) { var x = new Date(d + 'T12:00:00'); return x.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }); }
    function stars(r) { var h = '<span class="tps" style="--tps:20px" aria-hidden="true">'; for (var i = 1; i <= 5; i++) h += '<span class="tps__sq" style="--f:' + (i <= r ? 100 : 0) + '%">' + star + '</span>'; return h + '</span>'; }
    function more() {
      var html = '';
      list.slice(shown, shown + step).forEach(function (rv) {
        html += '<article class="rv__card"><span class="sp__stars" role="img" aria-label="' + rv.r + ' out of 5">' + stars(rv.r) + '</span>' +
          '<p class="rv__text">' + esc(rv.t) + '</p><p class="rv__meta"><strong>' + esc(rv.n) + '</strong> · ' + month(rv.d) +
          (rv.v && ver ? ' <em>' + esc(ver) + '</em>' : '') + '</p></article>';
      });
      grid.insertAdjacentHTML('beforeend', html); shown += step;
      if (btn) btn.hidden = shown >= list.length;
    }
    var extra = []; try { var xe = grid.parentNode.querySelector('[data-rv-extra]'); if (xe) extra = JSON.parse(xe.textContent || '[]').reverse(); } catch (x) {}
    fetch(grid.getAttribute('data-src')).then(function (r) { return r.json(); }).then(function (d) { list = extra.concat(d); more(); }).catch(function () { list = extra; more(); });
    if (btn) btn.addEventListener('click', more);
  });

  /* ---------- Product page: anyone can write a review (2026-10-07). Same store as the review emails:
     Shopify blog comment, body "N/5 text", auto-published; Shopify then shows the review thank-you page. ---------- */
  document.querySelectorAll('[data-rv-write]').forEach(function (box) {
    var open = document.querySelector('[data-rv-write-open]'), n = 0;
    var stars = Array.prototype.slice.call(box.querySelectorAll('[data-rv-star]'));
    var form = box.querySelector('[data-rr-review]'), err = box.querySelector('[data-rv-star-err]');
    if (open) open.addEventListener('click', function () { box.hidden = !box.hidden; open.setAttribute('aria-expanded', String(!box.hidden)); if (!box.hidden && stars[0]) stars[0].focus(); });
    stars.forEach(function (st) { st.addEventListener('click', function () {
      n = parseInt(st.getAttribute('data-rv-star'), 10);
      stars.forEach(function (x, k) { x.classList.toggle('is-on', k < n); x.setAttribute('aria-checked', k + 1 === n ? 'true' : 'false'); });
      if (err) err.hidden = true;
    }); });
    if (!form) return;
    form.addEventListener('focusin', function () {}, { once: true });
    form.addEventListener('submit', function (e) {
      if (!n) { e.preventDefault(); e.stopImmediatePropagation(); if (err) err.hidden = false; return; }
      var body = form.querySelector('[data-rr-body]'), txt = form.querySelector('[data-rr-text]');
      if (body) body.value = n + '/5 ' + (txt ? txt.value.trim() : '');
      var btn = form.querySelector('[type="submit"]'); if (btn) btn.textContent = 'Sending…';
      if (!form.dataset.hcaptchaBound && !form.dataset.rvWaiting) {
        form.dataset.rvWaiting = '1'; var t = 0;
        var iv = setInterval(function () { t += 1;
          if (form.dataset.hcaptchaBound) { clearInterval(iv); form.dataset.rvWaiting = ''; if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
          else if (t > 40) { clearInterval(iv); form.dataset.rvWaiting = ''; if (btn) btn.textContent = 'Publish my review'; } }, 250);
      }
    }, true);
  });

  /* ---------- Comparison header pinned under the site header on phones (CSS sticky; this keeps the offset exact
     because the site header can change height as the announcement bar scrolls away) ---------- */
  (function () {
    var cx = document.querySelector('.cx'), hdr = document.querySelector('.hdr');
    if (!cx || !hdr) return;
    var set = function () { var b = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)); cx.style.setProperty('--cx-top', b + 'px'); };
    set(); window.addEventListener('scroll', set, { passive: true }); window.addEventListener('resize', set);
  })();

  /* ---------- Carousel ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-track]');
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(car.querySelectorAll('[data-thumb]'));
    var prev = car.querySelector('[data-prev]');
    var next = car.querySelector('[data-next]');
    var current = 0;
    if (!slides.length) return;

    function goTo(i, behavior) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: behavior || 'smooth' });
    }
    function setCurrent(i) {
      if (i === current) return;
      current = i;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var live = car.querySelector('[data-live]');
      if (live) live.textContent = 'Image ' + (i + 1) + ' of ' + slides.length;
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var x = track.scrollLeft, best = 0, bestD = Infinity;
        slides.forEach(function (s, k) { var d = Math.abs((s.offsetLeft - track.offsetLeft) - x); if (d < bestD) { bestD = d; best = k; } });
        setCurrent(best);
        ticking = false;
      });
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    car.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });
  });

  /* ---------- Review strip: continuous moderate scroll; cards grow as they pass the centre; tap pauses/resumes ---------- */
  document.querySelectorAll('[data-rs-stage]').forEach(function (stage) {
    var track = stage.querySelector('[data-rs-track]');
    var cards = Array.prototype.slice.call(stage.querySelectorAll('[data-rs-card]'));
    if (!track || !cards.length) return;
    var sec = stage.closest('[data-rs-speed]');
    var speed = parseFloat(sec && sec.getAttribute('data-rs-speed')) || 35; /* px per second */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var paused = !!reduce, offset = 0, last = 0, half = 0, visible = true;
    /* touch: a finger on the strip holds it; dragging moves it (either way) and a flick throws it faster,
       then it eases back to the normal speed; a tap pauses with the nearest card centred, a second tap resumes */
    var holding = false, dragged = false, startX = 0, startY = 0, lastX = 0, lastT = 0, vel = 0, fling = 0, snapTo = null;
    var badge = stage.querySelector('[data-rs-paused]');
    function measure() { half = track.scrollWidth / 2; }
    function paint() {
      track.style.transform = 'translate3d(' + (-offset) + 'px,0,0)';
      var sr = stage.getBoundingClientRect(), mid = sr.left + sr.width / 2;
      cards.forEach(function (c) {
        var r = c.getBoundingClientRect(), w = c.offsetWidth || 1;
        var d = Math.abs((r.left + r.width / 2) - mid) / (w * 1.08); /* 0 at centre, 1 = one card away */
        var t = Math.min(d, 2.2);
        var sc = 1 - Math.min(t, 2) * 0.09;         /* 1 -> .91 -> .82 */
        var op = 1 - Math.max(0, t - 1) * 0.45;     /* full for centre + neighbours, fades further out */
        c.style.transform = 'scale(' + sc.toFixed(3) + ')';
        c.style.opacity = op.toFixed(3);
        c.classList.toggle('is-center', d < 0.5);
      });
    }
    function frame(ts) {
      if (!last) last = ts;
      var dt = Math.min(64, ts - last); last = ts;
      if (half && visible) {
        if (snapTo !== null) {
          /* shortest way round the loop, so a target past the wrap point never makes it chase forever */
          var gap = ((snapTo - offset) % half + half * 1.5) % half - half / 2;
          if (Math.abs(gap) < 0.5) { offset += gap; snapTo = null; } else offset += gap * Math.min(1, dt / 120);
        } else if (!holding) {
          if (Math.abs(fling) > 5) { offset += fling * dt / 1000; fling *= Math.pow(0.0025, dt / 1000); }
          else { fling = 0; if (!paused) offset += speed * dt / 1000; }
        }
        offset = ((offset % half) + half) % half;
      }
      paint();
      requestAnimationFrame(frame);
    }
    function setPaused(p) { paused = p; if (badge) badge.hidden = !p || reduce; stage.classList.toggle('is-paused', p); }
    function centreNearest() {
      var sr = stage.getBoundingClientRect(), mid = sr.left + sr.width / 2, best = null;
      cards.forEach(function (c) { var r = c.getBoundingClientRect(), d = (r.left + r.width / 2) - mid; if (best === null || Math.abs(d) < Math.abs(best)) best = d; });
      if (best !== null) snapTo = offset + best;
    }
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      holding = true; dragged = false; fling = 0; snapTo = null;
      startX = lastX = e.clientX; startY = e.clientY; lastT = e.timeStamp; vel = 0;
    });
    stage.addEventListener('pointermove', function (e) {
      if (!holding) return;
      var dx = e.clientX - lastX;
      if (!dragged && Math.abs(e.clientX - startX) > 8 && Math.abs(e.clientX - startX) > Math.abs(e.clientY - startY)) dragged = true;
      if (dragged) {
        offset -= dx;
        var dt = Math.max(1, e.timeStamp - lastT); vel = 0.8 * (-dx / dt * 1000) + 0.2 * vel;
      }
      lastX = e.clientX; lastT = e.timeStamp;
    });
    function release(e) {
      if (!holding) return;
      holding = false;
      if (dragged) { fling = (e && e.timeStamp - lastT > 80) ? 0 : Math.max(-4000, Math.min(4000, vel)); }
    }
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', function () { holding = false; dragged = false; });
    stage.addEventListener('pointerleave', release);
    stage.addEventListener('click', function (e) {
      if (dragged) { dragged = false; e.preventDefault(); return; }   /* a swipe is not a tap */
      setPaused(!paused);
      if (paused) centreNearest(); else snapTo = null;
    });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(stage);
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    measure(); setPaused(paused); requestAnimationFrame(frame);
  });

  /* ---------- Offer tiers → both add-to-cart forms + sticky bar ---------- */
  var buybox = document.querySelector('[data-buybox]');
  if (buybox) {
    var tierInputs = Array.prototype.slice.call(buybox.querySelectorAll('input[name="tier"]'));
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[data-atc-form]'));
    var priceOuts = Array.prototype.slice.call(document.querySelectorAll('[data-price-out]'));
    var wasOuts = Array.prototype.slice.call(document.querySelectorAll('[data-was-out]'));
    var labelOuts = Array.prototype.slice.call(document.querySelectorAll('[data-tier-label-out]'));

    var addonInputs = Array.prototype.slice.call(buybox.querySelectorAll('[data-addon-input]'));
    function addonByKey(k) { return addonInputs.filter(function (a) { return a.dataset.key === k; })[0] || null; }
    /* The top-up row (data-frees="<variant>") makes that add-on free: lock it ticked and show it at $0. */
    function syncFree() {
      addonInputs.forEach(function (a) {
        if (!a.dataset.frees) return;
        var freed = addonInputs.filter(function (b) { return b.dataset.variant === a.dataset.frees; })[0];
        if (!freed) return;
        var row = freed.closest('[data-addon]');
        var priceOut = row && row.querySelector('[data-addon-price]');
        var noteOut = row && row.querySelector('[data-addon-note]');
        if (a.checked) {
          if (!freed.dataset.wasChecked) freed.dataset.wasChecked = freed.checked ? '1' : '0';
          freed.checked = true; freed.disabled = true; freed.dataset.free = '1';
          if (row) row.setAttribute('data-locked', '');
          if (priceOut) { if (!priceOut.dataset.orig) priceOut.dataset.orig = priceOut.innerHTML; priceOut.innerHTML = '<strong>Free</strong>'; }
          if (noteOut) { if (!noteOut.dataset.orig) noteOut.dataset.orig = noteOut.textContent; noteOut.textContent = (freed.dataset.freeNote || noteOut.dataset.orig).replace('[top]', a.dataset.label || ''); }
        } else if (freed.dataset.free) {
          freed.disabled = false; delete freed.dataset.free;
          freed.checked = freed.dataset.wasChecked === '1'; delete freed.dataset.wasChecked;
          if (row) row.removeAttribute('data-locked');
          if (priceOut && priceOut.dataset.orig) priceOut.innerHTML = priceOut.dataset.orig;
          if (noteOut && noteOut.dataset.orig) noteOut.textContent = noteOut.dataset.orig;
        }
      });
    }
    function addonExtraCents() {
      return addonInputs.reduce(function (sum, a) { return sum + ((a.checked && !a.dataset.free) ? parseInt(a.dataset.priceCents || '0', 10) : 0); }, 0);
    }
    function addonSuffix() {
      return addonInputs.filter(function (a) { return a.checked; }).map(function (a) { return ' + ' + a.dataset.label + (a.dataset.free ? ' (free)' : ''); }).join('');
    }
    var moneyFmt = (document.documentElement.getAttribute('data-money') || '${{amount}}');
    function money(cents) {
      var n = (cents / 100).toFixed(2);
      return moneyFmt.replace('{{amount}}', n).replace('{{amount_no_decimals}}', Math.round(cents / 100));
    }
    function current() { return tierInputs.filter(function (i) { return i.checked; })[0] || tierInputs[0]; }
    function apply() {
      var input = current(); if (!input) return;
      var d = input.dataset;
      forms.forEach(function (f) {
        var id = f.querySelector('input[name="id"]');
        var qty = f.querySelector('input[name="quantity"]');
        if (id) id.value = d.variant || id.dataset.fallback || '';
        if (qty) qty.value = d.qty || '1';
      });
      var total = d.total || '';
      if (addonInputs.length && d.totalCents && addonExtraCents() > 0) {
        total = money(parseInt(d.totalCents, 10) + addonExtraCents());
      }
      priceOuts.forEach(function (o) { o.textContent = total; });
      /* savings pill: (compare-at of everything chosen) - (what they pay); free add-ons count in full */
      var saveOut = document.querySelector('[data-save-out]');
      if (saveOut && d.totalCents) {
        var now = parseInt(d.totalCents, 10) + addonExtraCents();
        var was = parseInt(d.wasCents || '0', 10) || parseInt(d.totalCents, 10);
        addonInputs.forEach(function (a) { if (a.checked) was += parseInt(a.dataset.wasCents || a.dataset.priceCents || '0', 10); });
        var save = was - now;
        if (save > 0) {
          var txt = 'You save ' + money(save);
          var topOn = addonInputs.some(function (a) { return a.dataset.frees && a.checked; });
          if (saveOut.innerHTML !== txt) {
            saveOut.innerHTML = txt;
            /* motion only when the third item (the one that frees the case) has just been added */
            if (topOn && !saveOut.dataset.topWas) { saveOut.classList.remove('is-bump'); void saveOut.offsetWidth; saveOut.classList.add('is-bump'); }
          }
          saveOut.dataset.topWas = topOn ? '1' : '';
        }
      }
      /* total line: threshold met → "Ships free" (+ the welcome code if this visitor holds it) */
      var tn = document.querySelector('[data-total-note]');
      if (tn && d.totalCents) {
        var tot = parseInt(d.totalCents, 10) + addonExtraCents(), th = parseInt(tn.dataset.threshold || '0', 10);
        var held = ''; try { held = localStorage.getItem('vantrel-welcome-code') || ''; } catch (e) {}
        var note = (!th || tot >= th) ? (th ? tn.dataset.over : tn.dataset.under) || '' : tn.dataset.under || '';
        if ((!th || tot >= th) && held && tn.dataset.code && held === tn.dataset.code && tn.dataset.codeNote) note += (note ? ' · ' : '') + tn.dataset.codeNote.replace('[code]', held);
        tn.textContent = note;
      }
      /* struck price = full price of everything chosen (device compare-at + each add-on at full price) */
      (function () {
        var nowC = parseInt(d.totalCents || '0', 10) + addonExtraCents();
        var wasC = parseInt(d.wasCents || '0', 10) || parseInt(d.totalCents || '0', 10);
        addonInputs.forEach(function (a) { if (a.checked) wasC += parseInt(a.dataset.wasCents || a.dataset.priceCents || '0', 10); });
        var show = wasC > nowC;
        wasOuts.forEach(function (o) { o.textContent = show ? money(wasC) : ''; o.hidden = !show; });
      })();
      labelOuts.forEach(function (o) { o.textContent = (d.label || '') + addonSuffix(); });
    }
    var giftTiles = Array.prototype.slice.call(buybox.querySelectorAll('[data-gift]'));
    function applyGifts() {
      var units = parseInt((current() && current().dataset.units) || '1', 10);
      giftTiles.forEach(function (g) { g.setAttribute('aria-pressed', units >= parseInt(g.dataset.unlock, 10) ? 'true' : 'false'); });
    }
    /* Sticky bar: pack select + strips toggle + pack image, mirrored with the buybox. */
    var stickySel = document.querySelector('[data-sticky-select]');
    var stickyAddons = Array.prototype.slice.call(document.querySelectorAll('[data-sticky-addon-input]'));
    var stickyUnits = document.querySelector('[data-sticky-units]');
    if (stickySel && tierInputs.length < 2) {
      stickySel.hidden = true;
      var stickyName = document.querySelector('[data-sticky-name]');
      if (stickyName) stickyName.hidden = false;
    }
    if (stickySel) {
      tierInputs.forEach(function (i, k) {
        var o = document.createElement('option'); o.value = String(k);
        o.textContent = (i.dataset.label || 'Pack') + ' · ' + (i.dataset.total || '');
        stickySel.appendChild(o);
      });
      stickySel.addEventListener('change', function () {
        var t = tierInputs[parseInt(stickySel.value, 10)];
        if (t && !t.checked) { t.checked = true; t.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    }
    stickyAddons.forEach(function (s) {
      var a = addonByKey(s.dataset.key);
      var wrap = s.closest('[data-sticky-addon]');
      if (!a) { if (wrap) wrap.hidden = true; return; }
      if (wrap) wrap.hidden = false;
      s.addEventListener('change', function () { if (a.disabled) { s.checked = a.checked; return; } if (a.checked !== s.checked) { a.checked = s.checked; a.dispatchEvent(new Event('change', { bubbles: true })); } });
    });
    function applySticky() {
      var cur = current(); if (!cur) return;
      if (stickySel) stickySel.value = String(tierInputs.indexOf(cur));
      stickyAddons.forEach(function (s) { var a = addonByKey(s.dataset.key); if (a) { s.checked = a.checked; s.disabled = a.disabled; } });
      if (stickyUnits) {
        var n = parseInt(cur.dataset.units || '1', 10);
        var img = stickyUnits.querySelector('img');
        if (img) { stickyUnits.innerHTML = ''; for (var q = 0; q < Math.min(n, 3); q++) stickyUnits.appendChild(img.cloneNode(true)); stickyUnits.setAttribute('data-n', String(n)); }
      }
    }
    tierInputs.forEach(function (i) { i.addEventListener('change', function () { apply(); applyGifts(); applySticky(); }); });
    addonInputs.forEach(function (a) { a.addEventListener('change', function () { syncFree(); apply(); applySticky(); }); });
    syncFree(); apply(); applyGifts(); applySticky();

    /* Add to cart via AJAX; falls back to the plain POST if anything fails. */
    forms.forEach(function (f) {
      f.addEventListener('submit', function (e) {
        var id = f.querySelector('input[name="id"]');
        if (!id || !id.value || !window.fetch) return; // let the browser post normally
        e.preventDefault();
        var btn = f.querySelector('[type="submit"]');
        if (btn) btn.setAttribute('aria-busy', 'true');
        fetch(f.action + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: (function () {
            var items = [{ id: id.value, quantity: parseInt(f.querySelector('input[name="quantity"]').value || '1', 10) }];
            var gifts = (current() && current().dataset.gifts || '').split(',').map(function (g) { return g.trim(); }).filter(Boolean);
            gifts.forEach(function (g) { items.push({ id: g, quantity: 1 }); });
            addonInputs.forEach(function (a) { if (a.checked && gifts.indexOf(a.dataset.variant) === -1) items.push({ id: a.dataset.variant, quantity: 1 }); });
            return items;
          })() })
        }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('vantrel:cart:added'));
            if (!document.querySelector('[data-cart-drawer]')) window.location.href = '/cart';
          })
          .catch(function () { f.submit(); })
          .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
      });
    });
  }

  /* ---------- Deconstruction: dot <-> list item ---------- */
  document.querySelectorAll('[data-deconstruction]').forEach(function (root) {
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-item]'));
    function set(n) {
      dots.forEach(function (d) { d.setAttribute('aria-current', d.dataset.dot === n ? 'true' : 'false'); });
      items.forEach(function (i) { i.setAttribute('aria-current', i.dataset.item === n ? 'true' : 'false'); });
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        set(d.dataset.dot);
        var it = items.filter(function (i) { return i.dataset.item === d.dataset.dot; })[0];
        if (it && window.matchMedia('(max-width: 1023px)').matches) it.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      d.addEventListener('mouseenter', function () { set(d.dataset.dot); });
    });
    items.forEach(function (i) { i.addEventListener('mouseenter', function () { set(i.dataset.item); }); });
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  function cartOpen() {
    if (!drawer) return;
    drawer.hidden = false; document.body.style.overflow = 'hidden';
    var c = drawer.querySelector('[data-cart-close]:not(.drawer__scrim)'); if (c) c.focus();
    startTimers(drawer); deliveryEstimate(drawer); ratingPreview(drawer);
  }
  function cartClose() { if (!drawer) return; drawer.hidden = true; document.body.style.overflow = ''; }
  function cartRefresh() {
    /* Root path on purpose: on /products/* Shopify answers a JSON Accept header with the
       product JSON, not the rendered section. Keep preview_theme_id so theme previews work. */
    var u = new URL('/', window.location.origin);
    u.searchParams.set('sections', 'cart-drawer');
    var pt = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (pt) u.searchParams.set('preview_theme_id', pt);
    return fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['cart-drawer']; if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-render]');
        var mine = drawer && drawer.querySelector('[data-cart-render]');
        if (fresh && mine) mine.innerHTML = fresh.innerHTML;
        var body = tmp.querySelector('[data-cart-body]');
        var n = body ? body.getAttribute('data-count') : '0';
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
        document.querySelectorAll('[data-cart-count-out]').forEach(function (el) { el.textContent = '(' + n + ')'; });
        if (drawer) { startTimers(drawer); deliveryEstimate(drawer); ratingPreview(drawer); }
      }).catch(function () {});
  }
  if (drawer) {
    document.querySelectorAll('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); cartRefresh().then(cartOpen); });
    });
    drawer.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', cartClose); });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') cartClose(); });
    document.addEventListener('vantrel:cart:added', function () { cartRefresh().then(cartOpen); });
  }

  /* Cart upsell (steriliser + free case): adds one or two variants, then refreshes the drawer. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-upsell-add]'); if (!b) return;
    e.preventDefault();
    var items = [{ id: b.getAttribute('data-upsell-add'), quantity: 1 }];
    var free = b.getAttribute('data-upsell-free'); if (free) items.push({ id: free, quantity: 1 });
    b.setAttribute('aria-busy', 'true'); b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('vantrel:cart:added'));
        if (!b.closest('[data-cart-drawer]')) window.location.reload();
      })
      .catch(function () { b.disabled = false; b.removeAttribute('aria-busy'); });
  });

  /* Quantity / remove / discount — delegated so re-rendered markup keeps working. */
  function changeLine(root, line, qty) {
    /* Decide before the refresh: the drawer swaps its markup, which detaches `root`. */
    var onPage = !(root && root.closest('[data-cart-drawer]'));
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () { return cartRefresh(); }).then(function () {
      if (onPage) window.location.reload();
    });
  }
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]'), rm = e.target.closest('[data-remove]');
    var li = e.target.closest('[data-line]'); if (!li) return;
    var input = li.querySelector('[data-qty-input]'); var line = parseInt(li.getAttribute('data-line'), 10);
    if (minus) changeLine(li, line, Math.max(0, parseInt(input.value, 10) - 1));
    else if (plus) changeLine(li, line, parseInt(input.value, 10) + 1);
    else if (rm) changeLine(li, line, 0);
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]'); if (!input) return;
    var li = input.closest('[data-line]');
    changeLine(li, parseInt(li.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
  });
  /* Discount codes: applied in place by the customer only (never for them). The cart re-renders with the
     code line and the new total; a code that does not apply is taken back off and explained. */
  function setCodes(codes) {
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.json(); });
  }
  function appliedCodes(root) {
    return Array.prototype.map.call(root.querySelectorAll('[data-code-applied]'), function (el) { return el.getAttribute('data-code-applied'); });
  }
  function afterCodeChange(onPage) {
    return onPage ? window.location.reload() : cartRefresh();
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-discount-form]'); if (!f) return;
    e.preventDefault();
    var body = f.closest('[data-cart-body]') || document;
    var onPage = !f.closest('[data-cart-drawer]');
    var input = f.querySelector('input[name="discount"]'), btn = f.querySelector('button[type="submit"]');
    var msg = body.querySelector('[data-code-msg]');
    var code = (input.value || '').trim().toUpperCase(); if (!code) return;
    var had = appliedCodes(body);
    if (had.some(function (c) { return c.toUpperCase() === code; })) { if (msg) { msg.textContent = code + ' is already applied.'; msg.hidden = false; } return; }
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    setCodes(had.concat(code)).then(function (c) {
      var hit = (c.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code; })[0];
      if (hit && hit.applicable) return afterCodeChange(onPage);
      return setCodes(had).then(function () {
        btn.disabled = false; btn.removeAttribute('aria-busy');
        if (msg) { msg.textContent = 'The code ' + code + ' does not work on this order.'; msg.hidden = false; }
      });
    }).catch(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  });
  document.addEventListener('click', function (e) {
    var x = e.target.closest('[data-code-remove]'); if (!x) return;
    var body = x.closest('[data-cart-body]') || document;
    var gone = x.getAttribute('data-code-remove');
    var onPage = !x.closest('[data-cart-drawer]');
    x.disabled = true;
    setCodes(appliedCodes(body).filter(function (c) { return c !== gone; })).then(function () { return afterCodeChange(onPage); });
  });
  /* Welcome popup: copy the code, never apply it. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy-code]'); if (!b) return;
    var code = b.getAttribute('data-copy-code');
    var done = function () { b.textContent = b.getAttribute('data-copied') || 'Copied'; };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  /* Cart hold timer. The clock starts when something is added and restarts on every add.
     At 0:00 the cart is emptied (the unit is released) and the empty state says so. The end
     time lives in localStorage so a reload, a second tab or a later visit cannot dodge it. */
  var TIMER_KEY = 'vantrel-cart-hold-end', EXPIRED_KEY = 'vantrel-cart-hold-expired', expiring = false;
  function store(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, String(v)); } catch (e) {} }
  function load(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function expireCart() {
    if (expiring) return; expiring = true;
    store(TIMER_KEY, null); store(EXPIRED_KEY, '1');
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function () {
        if (document.querySelector('[data-cart-body][data-count]') && !document.querySelector('[data-cart-drawer]')) { window.location.reload(); return; }
        if (document.querySelector('[data-cart-render]')) return cartRefresh();
      })
      .then(function () { showExpired(document); })
      .catch(function () {})
      .finally(function () { expiring = false; });
  }
  function showExpired(root) {
    if (load(EXPIRED_KEY) !== '1') return;
    root.querySelectorAll('[data-timer-expired]').forEach(function (el) { el.hidden = false; });
  }
  function startTimers(root) {
    showExpired(root);
    root.querySelectorAll('[data-cart-timer]').forEach(function (t) {
      if (t.dataset.running) return; t.dataset.running = '1';
      var mins = parseInt(t.getAttribute('data-cart-timer'), 10) || 5;
      var end = parseInt(load(TIMER_KEY), 10);
      if (!end || isNaN(end)) { end = Date.now() + mins * 60000; store(TIMER_KEY, end); store(EXPIRED_KEY, null); }
      var out = t.querySelector('[data-timer-out]');
      function tick() {
        if (!document.body.contains(t)) return;
        var stored = parseInt(load(TIMER_KEY), 10);
        if (stored && !isNaN(stored)) end = stored;
        var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (out) out.textContent = Math.floor(left / 60) + ':' + ('0' + (left % 60)).slice(-2);
        if (left <= 0) { expireCart(); return; }
        setTimeout(tick, 1000);
      }
      tick();
    });
  }
  document.addEventListener('vantrel:cart:added', function () { store(TIMER_KEY, null); store(EXPIRED_KEY, null); });

  /* Cart flow trigger: every add sends Klaviyo "Vantrel Added to Cart" with the items and a RestoreURL that rebuilds
     this exact cart with LUMEN10 applied. Klaviyo sends C1 ten minutes later, when the hold has run out. */
  document.addEventListener('vantrel:cart:added', function () {
    if (!window.klaviyo || !window.fetch) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c.items || !c.items.length) return;
      var lines = c.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
      var usd = function (cents) { return '$' + (cents / 100).toFixed(2); };
      window.klaviyo.track('Vantrel Added to Cart', {
        $value: c.total_price / 100,
        Items: c.items.map(function (i) {
          return { title: i.product_title, quantity: i.quantity, image: i.image, url: location.origin + i.url,
                   price: i.final_line_price ? usd(i.final_line_price) : 'Free', was: i.original_line_price > i.final_line_price ? usd(i.original_line_price) : '' };
        }),
        ItemNames: c.items.map(function (i) { return i.product_title; }),
        Total: usd(c.total_price),
        TotalWithCode: usd(Math.max(0, c.total_price - 1000)),
        /* storefront=true lands on the cart page (not checkout) with the items back and LUMEN10 applied */
        RestoreURL: location.origin + '/cart/' + lines + '?storefront=true&discount=LUMEN10'
      });
    }).catch(function () {});
  });
  /* Delivery dates: today + [min..max] calendar days (the supplier's door-to-door window). */
  function shipRange(min, max) {
    var a = new Date(); a.setDate(a.getDate() + min);
    var b = new Date(); b.setDate(b.getDate() + max);
    return [a, b];
  }
  function longDate(d) {
    var n = d.getDate(), suf = (n % 10 === 1 && n !== 11) ? 'st' : (n % 10 === 2 && n !== 12) ? 'nd' : (n % 10 === 3 && n !== 13) ? 'rd' : 'th';
    return d.toLocaleDateString('en-US', { weekday: 'long' }) + ', ' + d.toLocaleDateString('en-US', { month: 'long' }) + ' ' + n + suf;
  }
  function deliveryEstimate(root) {
    root.querySelectorAll('[data-delivery-estimate], [data-ship-dates]').forEach(function (el) {
      var lo = parseInt(el.getAttribute('data-min'), 10) || 0, hi = parseInt(el.getAttribute('data-max'), 10) || 0;
      var r = shipRange(lo, hi);
      var out = el.querySelector('[data-delivery-out]');
      if (out) out.textContent = r[0].toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ' – ' + r[1].toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      var f = el.querySelector('[data-ship-from]'), t = el.querySelector('[data-ship-to]');
      if (f) f.textContent = longDate(r[0]);
      if (t) t.textContent = longDate(r[1]);
    });
  }
  /* Rating blocks stay hidden until a real review count is set; ?reviews=preview shows them for this session */
  var RATING_PREVIEW = false;
  try {
    if (/[?&]reviews=preview/.test(location.search)) sessionStorage.setItem('vantrel-rating-preview', '1');
    RATING_PREVIEW = sessionStorage.getItem('vantrel-rating-preview') === '1';
  } catch (e) {}
  function ratingPreview(root) { if (RATING_PREVIEW) root.querySelectorAll('[data-rating-preview]').forEach(function (el) { el.hidden = false; }); }
  ratingPreview(document);
  startTimers(document); deliveryEstimate(document);

  /* ---------- Welcome popup: scratch card → email → code. 9s; declined → once more after 2 min; never after a claim ---------- */
  var pop = document.querySelector('[data-popup]');
  /* people arriving from one of our emails (?e=) are already on the list: no welcome popup */
  if (pop && /[?&]e=/.test(location.search)) pop = null;
  if (pop) {
    var key = pop.getAttribute('data-key');
    var S = { get: function (k) { try { return sessionStorage.getItem(key + ':' + k); } catch (e) { return null; } }, set: function (k, v) { try { sessionStorage.setItem(key + ':' + k, v); } catch (e) {} } };
    var claimed = ''; try { claimed = localStorage.getItem('vantrel-welcome-code') || ''; } catch (e) {}
    var shown = parseInt(S.get('shown') || '0', 10);
    function popOpen() {
      pop.hidden = false; document.body.style.overflow = 'hidden'; shown += 1; S.set('shown', String(shown)); var c = pop.querySelector('.pop__close'); if (c) c.focus();
      scratchInit();
      /* the card animates in; size the foil as soon as the box has real width (poll up to 4 s) */
      var tries = 0, tm = setInterval(function () { tries += 1; if (scratchSize && scratchSize()) clearInterval(tm); else if (tries > 20) clearInterval(tm); }, 200);
    }
    var scratchSize = null;
    function popClose() {
      pop.hidden = true; document.body.style.overflow = '';
      if (shown < 2 && !S.get('done') && !claimed) setTimeout(function () { afterConsent(function () { if (!drawerIsOpen() && pop.hidden && !S.get('done')) popOpen(); }); }, (parseInt(pop.getAttribute('data-retry'), 10) || 120) * 1000);
    }
    pop.querySelectorAll('[data-popup-close]').forEach(function (b) { b.addEventListener('click', popClose); });
    pop.addEventListener('keydown', function (e) { if (e.key === 'Escape') popClose(); });
    function step(n) { pop.querySelectorAll('[data-step]').forEach(function (s) { s.hidden = s.getAttribute('data-step') !== n; }); }

    /* survey mode (2026-10-28): one tap on a condition, then the email; the answer goes on the Klaviyo profile */
    var answer = '', answerText = '';
    pop.querySelectorAll('[data-answer]').forEach(function (b) {
      b.addEventListener('click', function () {
        answer = b.getAttribute('data-answer') || ''; answerText = b.getAttribute('data-answer-text') || b.textContent.trim();
        pop.querySelectorAll('[data-answer-label]').forEach(function (s) { s.textContent = answerText; });
        var tg = pop.querySelector('[data-pop-tags]'); if (tg && answer) tg.value = 'newsletter, hand-survey, concern-' + answer;
        step('2'); var inp = pop.querySelector('#pop-email'); if (inp) inp.focus();
      });
    });

    /* scratch card */
    var scratched = false;
    function scratchInit() {
      var cv = pop.querySelector('[data-scratch]'); if (!cv || cv.dataset.ready) return;
      cv.dataset.ready = '1';
      var box = cv.parentNode, ctx = cv.getContext('2d');
      function size() {
        var r = box.getBoundingClientRect(); if (r.width < 20) return false;   /* not laid out yet */
        cv.dataset.sized = '1';
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        cv.width = Math.round(r.width * dpr); cv.height = Math.round(r.height * dpr); cv.style.width = r.width + 'px'; cv.style.height = r.height + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var g = ctx.createLinearGradient(0, 0, r.width, r.height);
        g.addColorStop(0, '#0B7A5B'); g.addColorStop(.45, '#2FA383'); g.addColorStop(.55, '#178C6C'); g.addColorStop(1, '#075E46');
        ctx.fillStyle = g; ctx.fillRect(0, 0, r.width, r.height);
        ctx.fillStyle = 'rgba(251,248,243,.92)'; ctx.font = '700 ' + Math.max(14, Math.round(r.width / 14)) + 'px Inter, Arial, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText((cv.getAttribute('data-hint') || 'Scratch here').toUpperCase(), r.width / 2, r.height / 2);
        return true;
      }
      size(); scratchSize = size;
      if (window.ResizeObserver) new ResizeObserver(function () { if (!scratched && !cv.dataset.sized) size(); }).observe(box);
      window.addEventListener('resize', function () { if (!scratched && !cv.dataset.sized) size(); });
      var down = false, moved = 0;
      function pt(e) { var r = cv.getBoundingClientRect(); var s = e.touches ? e.touches[0] : e; return [s.clientX - r.left, s.clientY - r.top]; }
      function erase(e) {
        if (!cv.dataset.sized && !size()) return;
        var p = pt(e); ctx.globalCompositeOperation = 'destination-out'; ctx.beginPath(); ctx.arc(p[0], p[1], 22, 0, Math.PI * 2); ctx.fill(); ctx.globalCompositeOperation = 'source-over';
        moved += 1; if (moved % 6 === 0) check();
      }
      function check() {
        if (!cv.dataset.sized) return;   /* never reveal from an unpainted canvas */
        var w = cv.width, h = cv.height, data = ctx.getImageData(0, 0, w, h).data, clear = 0, total = 0;
        for (var i = 3; i < data.length; i += 4 * 9) { total++; if (data[i] === 0) clear++; }
        if (clear / total >= (parseInt(pop.getAttribute('data-threshold'), 10) || 30) / 100) reveal();
      }
      function reveal() {
        if (scratched) return; scratched = true;
        cv.style.transition = 'opacity .4s ease'; cv.style.opacity = '0';
        setTimeout(function () { cv.hidden = true; step('2'); var inp = pop.querySelector('#pop-email'); if (inp) inp.focus(); }, 700);
      }
      cv.addEventListener('pointerdown', function (e) { if (!cv.dataset.sized) size(); down = true; try { cv.setPointerCapture(e.pointerId); } catch (err) {} erase(e); });
      cv.addEventListener('pointermove', function (e) { if (down) erase(e); });
      cv.addEventListener('pointerup', function () { down = false; check(); });
      cv.addEventListener('pointercancel', function () { down = false; });
      /* real phones: claim the finger on the card itself so the page never steals the swipe */
      cv.addEventListener('touchstart', function (e) { e.preventDefault(); if (!cv.dataset.sized) size(); down = true; erase(e); }, { passive: false });
      cv.addEventListener('touchmove', function (e) { e.preventDefault(); if (down) erase(e); }, { passive: false });
      cv.addEventListener('touchend', function () { down = false; check(); });
      var skip = pop.querySelector('[data-scratch-skip]'); if (skip) skip.addEventListener('click', reveal);
    }

    var doneStep = pop.querySelector('[data-step="done"]');
    function popDone() {
      S.set('done', '1');
      var code = pop.getAttribute('data-code') || '';
      try { localStorage.setItem('vantrel-welcome-code', code || 'signed-up'); } catch (e) {}
      step('done');
      var tn = document.querySelector('[data-total-note]'); if (tn && typeof apply === 'function') apply();
    }
    var pf = pop.querySelector('form');
    var company = pop.getAttribute('data-klaviyo-company'), listId = pop.getAttribute('data-klaviyo-list');
    if (pf) pf.addEventListener('submit', function (e) {
      S.set('done', '1');
      if (!company || !listId || !window.fetch) return; // plain Shopify customer form
      e.preventDefault();
      var email = (pf.querySelector('#pop-email') || {}).value || '';
      var btn = pf.querySelector('[type="submit"]'); if (btn) btn.setAttribute('aria-busy', 'true');
      var body = { data: { type: 'subscription', attributes: { custom_source: 'Popup', profile: { data: { type: 'profile', attributes: { email: email, properties: (function () { var pr = { popup_answered_at: new Date().toISOString(), signup_interest: window.vlInterest() }; var c = pop.getAttribute('data-code') || ''; if (c) pr.welcome_code = c; if (answer) { pr.hand_concern = answerText; pr.hand_concern_key = answer; } return pr; })() } } } }, relationships: { list: { data: { type: 'list', id: listId } } } } };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-07-15' }, body: JSON.stringify(body)
      }).then(function (r) {
        if (r.status >= 200 && r.status < 300) { popDone(); try { if (window.klaviyo) window.klaviyo.identify({ email: email }); } catch (x) {} }
        else throw new Error('klaviyo');
      })
        .catch(function () { pf.submit(); })
        .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });
    var posted = pop.querySelector('[data-step="done"][data-posted="1"]');
    if (posted) { popDone(); popOpen(); }
    else if (!S.get('done') && !claimed && shown === 0) setTimeout(function () { afterConsent(function () { if (!drawerIsOpen() && pop.hidden && !S.get('done')) popOpen(); }); }, (parseInt(pop.getAttribute('data-delay'), 10) || 9) * 1000);
  }
  /* never open the popup under Shopify's cookie banner (on phones it covers the lower half, incl. the email field):
     if the banner is up when the timer fires, wait until the visitor answers it, then open 1.2 s later */
  function afterConsent(cb) {
    function bannerUp() { var b = document.getElementById('shopify-pc__banner'); return !!(b && b.offsetParent !== null && b.getBoundingClientRect().height > 0); }
    if (!bannerUp()) return cb();
    var fired = false;
    function go() { if (fired) return; fired = true; clearInterval(iv); setTimeout(cb, 1200); }
    document.addEventListener('visitorConsentCollected', go);
    var iv = setInterval(function () { if (!bannerUp()) go(); }, 800);
  }
  function drawerIsOpen() { return drawer && !drawer.hidden; }


  /* ---------- Review page (/pages/review?r=1..5&e=email), merchant design 2026-10-06 ----------
     3-5 stars: review form (published on the site) + Trustpilot. 1-2 stars: private feedback (contact form ->
     store inbox + Klaviyo "Lumen Feedback"), then an optional public review + Trustpilot. Every review form
     prefixes the body with "N/5 " so the product page knows the stars (Shopify strips square brackets). */
  var rr = document.querySelector('[data-review-router]');
  if (rr) {
    var q = new URLSearchParams(window.location.search);
    var KEY = 'vl-review';
    var saved = {}; try { saved = JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (x) {}
    var rrEmail = (q.get('e') || saved.e || '').replace(/ /g, '+'), rating = 0, sent = false;
    /* 2026-10-23: ?p=vantrel-wrap -> Wrap review (Wrap emails); otherwise the Lumen, as before */
    /* a link from an email always carries r= (and p= for the Wrap); only the feedback post-back (no query) falls back to the session */
    var prod = q.get('p') === 'vantrel-wrap' ? 'wrap' : ((q.get('r') || q.get('p')) ? 'lumen' : (saved.p || 'lumen'));
    var PNAME = prod === 'wrap' ? 'Vantrel Wrap' : 'Vantrel Lumen';
    rr.querySelectorAll('[data-rr-prod]').forEach(function (b) { b.hidden = b.getAttribute('data-rr-prod') !== prod; });
    rr.querySelectorAll('[data-rr-subject]').forEach(function (f) { if (prod === 'wrap') f.value = '[Wrap feedback] 1-2 stars: a customer needs help'; });
    var company = rr.getAttribute('data-company') || 'Vbjrbj';
    var stars = Array.prototype.slice.call(rr.querySelectorAll('[data-rr-star]'));
    function save() { try { sessionStorage.setItem(KEY, JSON.stringify({ r: rating, e: rrEmail, p: prod })); } catch (x) {} }
    function kv(metric, props, pprops) {
      if (!rrEmail || !window.fetch) return;
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(company), { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-07-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: { metric: { data: { type: 'metric', attributes: { name: metric } } }, profile: { data: { type: 'profile', attributes: { email: rrEmail, properties: pprops || {} } } }, properties: props } } }) }).catch(function () {});
    }
    function rrSet(n, quiet) {
      rating = n; save();
      stars.forEach(function (s, k) { s.setAttribute('aria-checked', k + 1 === n ? 'true' : 'false'); s.classList.toggle('is-on', k < n); });
      var hi = rr.querySelector('[data-rr-branch="high"]'), lo = rr.querySelector('[data-rr-branch="low"]');
      if (hi) hi.hidden = n < 3; if (lo) lo.hidden = n >= 3;
      rr.querySelectorAll('[data-rr-rating-field]').forEach(function (f) { f.value = String(n); });
      rr.querySelectorAll('[data-rr-email-field]').forEach(function (f) { if (rrEmail && !f.value) f.value = rrEmail; });
      if (!quiet && !sent) { sent = true; kv('Rated Lumen', { rating: n, source: 'review-email', product: PNAME }, { lumen_rating: n, lumen_rated_at: new Date().toISOString() }); }
    }
    stars.forEach(function (s) { s.addEventListener('click', function () { sent = false; rrSet(parseInt(s.getAttribute('data-rr-star'), 10)); }); });
    /* Shopify's spam check (hCaptcha) loads on first focus; a submit before it is ready is swallowed.
       Show "Sending…" and resubmit by ourselves as soon as it is ready. */
    function rrWaitCaptcha(f) {
      var btn = f.querySelector('[type="submit"]'); if (btn && !btn.dataset.lbl) { btn.dataset.lbl = btn.textContent; btn.textContent = 'Sending…'; btn.disabled = false; }
      if (f.dataset.hcaptchaBound || f.dataset.rrWaiting) return;
      f.dataset.rrWaiting = '1'; var n = 0;
      var iv = setInterval(function () {
        n += 1;
        if (f.dataset.hcaptchaBound) { clearInterval(iv); f.dataset.rrWaiting = ''; if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
        else if (n > 40) { clearInterval(iv); f.dataset.rrWaiting = ''; if (btn) btn.textContent = btn.dataset.lbl; }
      }, 250);
    }
    /* every public review: "[N] text", and a Klaviyo copy */
    rr.querySelectorAll('[data-rr-review]').forEach(function (f) {
      f.addEventListener('submit', function () {
        var body = f.querySelector('[data-rr-body]'), txt = f.querySelector('[data-rr-text]'), em = f.querySelector('[name="comment[email]"]');
        if (em && em.value) { rrEmail = em.value.trim(); save(); }
        var t = txt ? txt.value.trim() : '';
        if (body) body.value = (rating || 5) + '/5 ' + t;
        if (!f.dataset.rrSent) { f.dataset.rrSent = '1'; kv('Reviewed Lumen', { rating: rating, review: t, product: PNAME }, { lumen_rating: rating, lumen_reviewed: true }); }
        rrWaitCaptcha(f);
      });
    });
    /* 1-2 stars: the private feedback, also to Klaviyo (the contact form email is the inbox alert) */
    var fb = rr.querySelector('[data-rr-feedback]');
    if (fb && fb.querySelector('[name="contact[better]"]')) fb.addEventListener('submit', function () {
      var em = fb.querySelector('[name="contact[email]"]'); if (em && em.value) { rrEmail = em.value.trim(); save(); }
      var probs = Array.prototype.map.call(fb.querySelectorAll('[data-rr-problem]:checked'), function (c) { return c.value; });
      var ph = fb.querySelector('[data-rr-problems]'); if (ph) ph.value = probs.join('; ');
      var help = fb.querySelector('[name="contact[help]"]:checked');
      if (!fb.dataset.rrSent) { fb.dataset.rrSent = '1';
      kv('Lumen Feedback', { product: PNAME, rating: rating, problems: probs.join('; '), better: fb.querySelector('[name="contact[better]"]').value, help: help ? help.value : '', phone: (fb.querySelector('[name="contact[phone]"]') || {}).value || '' },
         { lumen_rating: rating, lumen_feedback_help: help ? help.value : '' }); }
      rrWaitCaptcha(fb);
    });
    /* first load: rating from the email link; after the feedback form posts back: show the low branch + public review */
    var r0 = parseInt(q.get('r') || '0', 10);
    if (rr.querySelector('[data-rr-low-done]')) {
      rrSet(saved.r && saved.r < 3 ? saved.r : 2, true);
      var after = rr.querySelector('[data-rr-low-after]'); if (after) after.hidden = false;
      var sub = rr.querySelector('[data-rr-sub]'); if (sub) sub.hidden = true;
    } else if (r0 >= 1 && r0 <= 5) rrSet(r0);
    else if (saved.r) rrSet(saved.r, true);
  }


  /* ---------- Email answer links: ?reason=… (why didn't you finish) and ?arrived=… (delivery check) ---------- */
  (function () {
    var q = new URLSearchParams(window.location.search);
    var reason = q.get('reason'), arrived = q.get('arrived'), concern = q.get('concern'), email = (q.get('e') || '').replace(/ /g, '+'); /* a '+' in an address arrives as a space after Shopify's redirect */
    if (!reason && !arrived && !concern) return;
    var company = (document.querySelector('[data-popup]') || {}).getAttribute ? (document.querySelector('[data-popup]').getAttribute('data-klaviyo-company') || 'Vbjrbj') : 'Vbjrbj';
    /* ?concern=… comes from the welcome email's "What brings you to Lumen?" buttons: stored on the profile for good */
    var metric = reason ? 'Checkout Reason' : concern ? 'Shared Concern' : 'Delivery Check';
    var props = reason ? { reason: reason } : concern ? { concern: concern } : { arrived: arrived };
    var pprops = reason ? { checkout_reason: reason } : concern ? { concern: concern } : { delivery_check: arrived };
    function send(m, p, pp) {
      if (!email || !window.fetch) return;
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(company), { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-07-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: { metric: { data: { type: 'metric', attributes: { name: m } } }, profile: { data: { type: 'profile', attributes: { email: email, properties: pp } } }, properties: p } } }) }).catch(function () {});
    }
    function toast(msg) {
      var t = document.createElement('div'); t.setAttribute('role', 'status'); t.className = 'toast'; t.textContent = msg; document.body.appendChild(t);
      setTimeout(function () { t.classList.add('is-on'); }, 50); setTimeout(function () { t.classList.remove('is-on'); }, 6000);
    }
    send(metric, props, pprops);
    try { if (email && window.klaviyo) window.klaviyo.identify({ email: email }); } catch (x) {}
    /* A free-text sheet: "Something else" (concern_note) and "parcel not in perfect condition" (delivery_note) */
    function ask(title, sub, placeholder, foot, done) {
      var box = document.createElement('div'); box.className = 'ask'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-labelledby', 'ask-h');
      box.innerHTML = '<form class="ask__card"><button type="button" class="ask__x" aria-label="Close">&times;</button>' +
        '<h2 id="ask-h" class="ask__h"></h2><p class="ask__p"></p>' +
        '<textarea class="ask__in" name="note" rows="4" maxlength="500" required></textarea>' +
        '<button type="submit" class="btn ask__go">Send</button><p class="ask__s"></p></form>';
      box.querySelector('.ask__h').textContent = title; box.querySelector('.ask__p').textContent = sub;
      box.querySelector('.ask__in').placeholder = placeholder; box.querySelector('.ask__s').textContent = foot;
      document.body.appendChild(box);
      var close = function () { box.remove(); };
      box.querySelector('.ask__x').addEventListener('click', close);
      box.addEventListener('click', function (e) { if (e.target === box) close(); });
      box.querySelector('form').addEventListener('submit', function (e) {
        e.preventDefault();
        var note = box.querySelector('.ask__in').value.trim(); if (!note) return;
        done(note); close();
      });
      setTimeout(function () { box.querySelector('.ask__in').focus(); }, 100);
    }
    if (concern === 'other') {
      ask('What brings you to Lumen?', 'In your own words. A person reads every answer.', 'For example: my nose blocks every evening after work', 'Your $10 code is already applied at checkout.', function (note) {
        send('Shared Concern', { concern: 'other', note: note }, { concern: 'other', concern_note: note });
        toast('Thank you for telling us. Your $10 code is ready at checkout.');
      });
      return;
    }
    if (reason === 'other') {
      ask('What stopped you?', 'In your own words. A person reads every answer.', 'For example: I wanted to ask a question first', 'Your order is still saved if you change your mind.', function (note) {
        send('Checkout Reason', { reason: 'other', note: note }, { checkout_reason: 'other', checkout_reason_note: note });
        toast('Thank you for telling us. It really helps.');
      });
      return;
    }
    if (arrived === 'issue') {
      ask('What went wrong with your parcel?', 'Tell us what happened. A person will sort it out within one business day.', 'For example: the box was crushed, or the parcel never arrived', 'Photos help: you can also reply to the delivery email with them.', function (note) {
        send('Delivery Check', { arrived: 'issue', note: note }, { delivery_check: 'issue', delivery_note: note });
        toast('Thank you. A person will be in touch within one business day.');
        /* also to the store inbox: the Help page's Shopify contact form (the alert) */
        var ff = document.querySelector('input[name="form_type"][value="contact"]'); var cf = ff && ff.form;
        if (cf && email) {
          var set = function (n, v) { var el = cf.querySelector('[name="' + n + '"]'); if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = n; cf.appendChild(el); } el.value = v; };
          set('contact[email]', email); set('contact[subject]', '[Parcel problem] reported from the Delivered email');
          set('contact[body]', 'Parcel problem reported from the Delivered email: ' + note);
          cf.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
          var tries = 0, iv = setInterval(function () { tries += 1;
            if (cf.dataset.hcaptchaBound || tries > 40) { clearInterval(iv); if (cf.requestSubmit) cf.requestSubmit(); else cf.submit(); } }, 250);
        }
      });
      return;
    }
    toast(reason ? 'Noted, thank you. That was our last email about this order.' : concern ? 'Thank you for telling us. Your $10 code is ready at checkout.' : (arrived === 'good' ? 'Thank you. Enjoy your first session.' : 'Thank you. A person will be in touch within one business day.'));
  })();

  /* ---------- Engaged view: 60 seconds on the Lumen page (visible tab) -> Klaviyo "Viewed Lumen 1 Minute".
     Starts the browse flow only for real interest, once per browser session. ---------- */
  (function () {
    if (!/\/products\/vantrel-lumen/.test(location.pathname)) return;
    var KEY = 'vantrel-engaged-sent', secs = 0;
    try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}
    var iv = setInterval(function () {
      if (document.visibilityState !== 'visible') return;
      if (++secs < 60) return;
      clearInterval(iv);
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      try {
        if (window.klaviyo) window.klaviyo.track('Viewed Lumen 1 Minute', {
          ProductName: 'Vantrel Lumen', URL: location.origin + '/products/vantrel-lumen',
          ImageURL: location.origin + '/cdn/shop/t/3/assets/img-home-podium.jpg', Seconds: 60
        });
      } catch (e) {}
    }, 1000);
  })();

  /* ---------- Sticky add-to-cart: show once the main CTA has scrolled past ---------- */
  var sticky = document.querySelector('[data-sticky]');
  var anchor = document.querySelector('[data-sticky-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var en = entries[0];
      var past = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.setAttribute('data-visible', past ? 'true' : 'false');
      sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
    }, { threshold: 0 });
    io.observe(anchor);
  }
})();
